module.exports = __webpack_public_path__ + "images/Sketchy-2.bbbf649b3a5a647337155d421b370dc9.png";